export default "__VITE_ASSET__b5c5e437__"